import React, { useCallback, useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { KnowledgeSwitch } from "./knowledge/KnowledgeSwitch";
import { KnowledgeLotImport } from "./knowledge/KnowledgeLotImport";
import { ManualsTable } from "./knowledge/ManualsTable";
import { ReaderConnectionSettings } from "@/components/ReaderConnectionInfo";

/** Configurazione → Conoscenza lettore: che cosa è importato, che cosa è attivo, che cosa arriva al modello. */
export const ReaderKnowledge = () => {
  const [src, setSrc] = useState(null), [error, setError] = useState("");
  const load = useCallback(() => api.get("/knowledge-sources", { timeout: 60000 }).then(r => { setSrc(r.data); setError(""); }).catch(e => setError(formatApiErrorDetail(e.response?.data?.detail))), []);
  useEffect(() => { load(); }, [load]);
  useEffect(() => { if (!src || src.counts.processing === 0) return; const t = setInterval(load, 3000); return () => clearInterval(t); }, [src, load]);
  if (error) return <p role="alert" className="text-sm text-destructive py-4" data-testid="knowledge-error">{error}</p>;
  if (!src) return <p className="text-sm py-4" data-testid="knowledge-loading">Caricamento stato fonti…</p>;
  const cfg = src.reader_knowledge_context;
  return <section className="py-5 space-y-5 min-w-0" data-testid="reader-knowledge-panel">
    <ReaderConnectionSettings />
    <div><h2 className="text-base md:text-lg font-semibold">Conoscenza del lettore</h2>
      <p className="text-sm text-muted-foreground" data-testid="knowledge-summary">Importato: {src.lots.length} lotto/i revisionato/i · {src.lessons.length} lezioni · {src.counts.ready}/{src.counts.expected} manuali pronti. Attivo per le letture: <b>{cfg.enabled ? "SÌ" : "NO"}</b>{cfg.enabled && cfg.attach_manual_page_images ? " (con immagini di pagina)" : ""}. {src.sent_to_model_rule}</p></div>
    <KnowledgeSwitch key={cfg.updated_at || "default"} cfg={cfg} onSaved={load} />
    <ManualsTable sources={src} onChanged={load} />
    <KnowledgeLotImport lots={src.lots} lessons={src.lessons} onImported={load} />
  </section>;
};
